import React, { memo } from 'react'
import { useFAQItem, FAQItemProps } from './useFAQItem'
import styles from './FAQItem.module.scss'

const FAQItem: React.FC<FAQItemProps> = (props: FAQItemProps) => {
  const { question, answer, isActive, handleClick } = useFAQItem(props)

  return (
    <div
      className={`${styles['faq-item']} ${
        isActive ? styles['faq-active'] : ''
      }`}
      onClick={() => handleClick()}
    >
      <h3 onClick={() => handleClick()}>{question}</h3>
      <div
        className={`${styles['faq-content']} ${
          isActive ? styles['faq-open'] : styles['faq-closed']
        }`}
        dangerouslySetInnerHTML={answer}
      ></div>
      <i
        className={`bi bi-chevron-down ${styles['faq-toggle']}`}
        onClick={() => handleClick()}
      ></i>
    </div>
  )
}

export default memo(FAQItem)
